module.exports = __webpack_public_path__ + "static/logo-round-5c491971d9c27828bef681359abea361.svg";